var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('panel-modal-options-json',{key:'panel-options-json' + _vm.panel_modal.panel_id,staticClass:"w-100 h-100",attrs:{"item":_vm.panel_modal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }